import React, { useEffect } from "react";

const GOOGLE_CLIENT_ID = "234070932893-4ba483jeo3s02ru71dledn9i48ld75ea.apps.googleusercontent.com";

const GoogleLoginPopup: React.FC = () => {
  useEffect(() => {
    // Immediately redirect to Google OAuth URL for authorization code flow
    const redirectUri = "https://webchat.supportedbusiness.com/auth/callback";
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get("clientId") || "";
    const mode = urlParams.get("mode") || "login";
    const dateOfBirth = urlParams.get("dateOfBirth") || "";
    
    // Store in localStorage for the callback to use
    localStorage.setItem('ClientID', clientId);
    localStorage.setItem('OAuthMode', mode);
    localStorage.setItem('OAuthDateOfBirth', dateOfBirth);
    
    const authUrl = new URL("https://accounts.google.com/o/oauth2/v2/auth");
    authUrl.searchParams.set("client_id", GOOGLE_CLIENT_ID);
    authUrl.searchParams.set("redirect_uri", redirectUri);
    authUrl.searchParams.set("response_type", "code");
    authUrl.searchParams.set("scope", "openid email profile");
    authUrl.searchParams.set("access_type", "offline");
    authUrl.searchParams.set("prompt", "select_account");
    
    // Redirect to Google OAuth consent screen
    window.location.href = authUrl.toString();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #4285f4 0%, #34a853 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          padding: "40px 32px 32px 32px",
          minWidth: 340,
          maxWidth: 400,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Official Google Logo */}
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" style={{marginBottom: 16}}>
          <path fill="#ffc107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
          <path fill="#ff3d00" d="m6.306 14.691 6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
          <path fill="#4caf50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
          <path fill="#1976d2" d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
        </svg>
        
        <h2 style={{ color: "#202124", margin: 0, fontWeight: 400, fontSize: 24, fontFamily: "'Google Sans', Roboto, sans-serif" }}>Redirecting to Google</h2>
        <p style={{ color: "#5f6368", margin: "12px 0 24px 0", fontSize: 14, textAlign: "center", fontFamily: "'Google Sans', Roboto, sans-serif" }}>
          Please wait while we redirect you to Google for secure sign-in.
        </p>
        
        {/* Google-style loading spinner */}
        <div style={{
          width: 24,
          height: 24,
          border: "3px solid #f3f3f3",
          borderTop: "3px solid #4285f4",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default GoogleLoginPopup;
